<template>
  <s-section
    type="gray"
    is-centered
    class="products"
    :title="products.title"
    :subtitle="products.subtitle"
  >
    <template v-if="isCompactView">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <div class="products__grid products__grid--compact">
            <products-item
              v-for="item in products.items"
              :key="item.id"
              :item="item"
            ></products-item>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="products__grid">
        <products-item
          v-for="item in products.items"
          :key="item.id"
          :item="item"
        ></products-item>
      </div>
    </template>
  </s-section>
</template>

<script>
import Vue from 'vue'

import ProductsItem from './ProductsItem.vue'

export default Vue.extend({
  name: 'Products',
  components: {
    ProductsItem
  },
  props: {
    products: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    isCompactView() {
      return this.products.items.length % 3 !== 0
    }
  }
})
</script>

<style lang="scss">
.products__grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;
  justify-content: center;

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;
  }

  @media (max-width: $breakpoint-sm) {
    grid-template-columns: 1fr;
  }
}

.products__grid--compact {
  grid-template-columns: 1fr 1fr;

  @media (max-width: $breakpoint-sm) {
    grid-template-columns: 1fr;
  }
}
</style>